import React from "react";
import Flx from "./Flx";
import BrandedCard from "../common/BrandedCard";

const ScreenLayoutFormCard = ({
  title,
  description,
  cardWidth,
  children,
  partner,
  sx,
}) => {
  return (
    <Flx
      center
      column
      sx={{
        p: 1,
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        ...sx,
      }}
    >
      <BrandedCard
        partner={partner}
        title={title}
        width={cardWidth}
        description={description}
      >
        {children}
      </BrandedCard>
    </Flx>
  );
};

export default ScreenLayoutFormCard;
